import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Riporta automaticamente lo scroll in cima alla pagina ad ogni cambio di rotta.
 * Va inserito UNA volta dentro <BrowserRouter> in App.js.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Behavior 'auto' = istantaneo. Usa 'smooth' se preferisci animato.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
